import React from 'react';

export const LazyUserManagementListPage = React.lazy(() => import('./UserManagementListPage'));
